import { render, staticRenderFns } from "./DendaPenalti.vue?vue&type=template&id=5e2ed5f6&scoped=true&"
import script from "./DendaPenalti.vue?vue&type=script&lang=js&"
export * from "./DendaPenalti.vue?vue&type=script&lang=js&"
import style0 from "./DendaPenalti.vue?vue&type=style&index=0&id=5e2ed5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ed5f6",
  null
  
)

export default component.exports